"use client"

import { defineSlotRecipe } from "@chakra-ui/react"
import { popoverAnatomy } from "@chakra-ui/react/anatomy"

const table = defineSlotRecipe({
  className: "hydrologiq-popover",
  slots: popoverAnatomy.keys(),

  variants: {
    variant: {
      hydrologiq: {
        content: {
          padding: "0.625rem",
          fontWeight: "normal",
          fontSize: "0.8125rem",
          lineHeight: "1.35",
          textAlign: "start",
          color: "primary",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "0.3125rem",
          boxShadow: "0 0.25rem 1rem rgba(0, 0, 0, 0.12), 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08)",
          textTransform: "none",
          "--popover-bg": "var(--planner-colors-background, #F2F0EF)",
          bg: "var(--popover-bg)",
          textWrap: "auto",
        },
        arrow: {
          "--arrow-size": "0.75rem",
          "--arrow-background": "var(--planner-colors-background, #F2F0EF)",
        },
        arrowTip: {
          borderTopWidth: "1px",
          borderLeftWidth: "1px",
          borderColor: "divider",
          bg: "var(--planner-colors-background, #F2F0EF)",
        },
      },
    },
    size: {},
  },
})

export default table
